import React, { Component } from 'react';
import { AddUserProps, AddUserState } from '../../interfaces/user'
import { connect } from 'react-redux'
import Topbar from '../topbar/topbar'
import Sidebar from '../sidebar/sidebar'
import Footer from '../footer/footer'
import CheckChanges from '../confirmOnLeave';
import { Link, Redirect } from 'react-router-dom';
import { addUser, courseGroupList, groupList, logoutUser, roleList } from '../../redux/actions/user';
import { validatePassword } from '../../utils/passwordValidation';
import config from '../config/setting'
import Select from 'react-select';
import { withAuth } from '../withAuth';

class AddUser extends Component<AddUserProps, AddUserState> {
    constructor(props: any) {
        super(props);
        this.state = {
            name: "",
            role: "",
            email: "",
            phone: "",
            username: "",
            address: "",
            group: "",
            password: "",
            confirmPassword: "",
            status: config.ACTIVE,
            isValidEmail: true,
            isValidPhone: true,
            passwordStrength: 0,
            passwordErrors: [],
        }
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.props.roleList();
        this.props.groupList();
    }
    handleInputChange(event: { target: { name: any; value: any; }; }) {
        const { name, value } = event.target;
        if (value[0] === " ") {
            return;
        }
        this.setState({
            [name]: value,
        });
    }

    handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        if (value[0] === " ") {
            return;
        }

        const result = validatePassword(value);

        this.setState({
            password: value,
            passwordStrength: result.strength,
            passwordErrors: result.isValid ? [] : result.errors,
        });
    };

    handleGroupsInputChange = (e: any) => {
        if (e && e.value > 0) {
            this.setState({ group: e.value });
        } else {
            this.setState({ group: "" });
        }
    };

    isUserReady = () => {
        const { name, role, email, phone, group, address, password, confirmPassword, status, passwordErrors } = this.state;

        if (!name || !role || !email || !group || !phone || !address || !password || !confirmPassword || !status) {
            return false;
        }

        if (password !== confirmPassword) {
            return false;
        }

        if (passwordErrors && passwordErrors.length > 0) {
            return false;
        }

        return true;
    }

    validateEmail = (event: { target: { name: any; value: any; }; }) => {
        var reg = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (reg.test(event.target.value) === false) {
          this.setState({ email: event.target.value, isValidEmail: false })
        } else {
          this.setState({ email: event.target.value, isValidEmail: true });
        }
        };
    handlePhoneKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const key = event.key;
        const currentValue = (event.target as HTMLInputElement).value;
        
        // Allow control keys (backspace, delete, tab, arrows)
        const controlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
        if (controlKeys.includes(key)) {
            return;
        }
        
        // Block non-digit keys
        if (!/^\d$/.test(key)) {
            event.preventDefault();
            return;
        }
        
        // Block if already 11 digits
        if (currentValue.length >= 11) {
            event.preventDefault();
        }
    };

    validatePhone = (event: { target: { name: any; value: any; }; }) => {
        let value = event.target.value;
        // Remove anything that's not a number
        let numericValue = value.replace(/\D/g, "");
        // Trim to max 11 digits
        if (numericValue.length > 11) {
            numericValue = numericValue.slice(0, 11);
        }
        
        this.setState({ phone: numericValue, isValidPhone: true });
    };

    handleSaveBtnClick = (event: any) => {
        const { name, role, email, phone, group, address, password, confirmPassword, status, passwordErrors } = this.state;

        if (!this.isUserReady()) {
            return;
        }

        if (password !== confirmPassword) {
            return;
        }

        if (passwordErrors && passwordErrors.length > 0) {
            return;
        }

        const data = {
            name,
            group,
            role,
            email,
            phone,
            address,
            password,
            status,
            isActive: 1,
        };

        this.props.addUser(data);
    }
    render() {
        let msg;
        let messcolor;

        let { roles, groups } = this.props;

        // Groups Data
        let groupData: any = [];
        groups.forEach((element: any) => {
            var group = { value: element.id, label: element.name };
            groupData.push(group);        
        });

        return (
            <div className="page">
                <CheckChanges path="/add-user" />
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">
                        {/* <!-- Page Header--> */}
                        <header className="page-header pb-1">
                            <div className="container-fluid">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h4>Users Management</h4>
                                </div>
                            </div>
                        </header>
                        {/*  Breadcrumb */}
                        <div className="breadcrumb-holder container-fluid">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/users" className="text-primary">Users</Link></li>
                                <li className="breadcrumb-item active">Add User</li>
                            </ul>
                        </div>
                        <section className="forms">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body pt-xl-0">
                                                <strong><p className="text-center font-weight-light mb-4" style={{ color: messcolor }}>
                                                    {msg}
                                                </p></strong>

                                                <div className="card-header card-header-info d-flex align-items-center">
                                                    <h5>Personal Information</h5>
                                                </div>

                                                <div className="form-horizontal p-xl-4">

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Name<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="name" type="text" name="name" required data-msg="Please enter Store Name" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Role<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="role" className="form-control text-capitalize mt-2" required data-msg="Please select role" onChange={this.handleInputChange}>
                                                                <option>Select Role</option>
                                                                {
                                                                    roles.map((role1: any) => (
                                                                        <option key={role1.id} value={role1.id}>{role1.name}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Group<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                        {groups.length > 0 &&
                                                                    <Select
                                                                        closeMenuOnSelect={true}
                                                                        name="group"
                                                                        options={groupData}
                                                                        className="basic-multi-select"
                                                                        classNamePrefix="select"
                                                                        onChange={(e: any) => this.handleGroupsInputChange(e)}
                                                                    />
                                                                }
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Address<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="address" type="text" name="address" required data-msg="Please enter Store Name" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    {/* Email Info */}
                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Email<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="email" type="email" name="email" required data-msg="Please enter Email" className="input-material" onChange={this.validateEmail} autoComplete="off" />
                                                            {(this.state.isValidEmail == false && this.state.email !== "") &&
                                                            <small className="form-text text-danger">Invalid Email</small>}
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Phone<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="phone" type="text" name="phone" required data-msg="Please enter Phone" className="input-material" onChange={this.validatePhone} onKeyDown={this.handlePhoneKeyPress} />
                                                            {(this.state.isValidPhone == false && this.state.phone !== "") &&
                                                            <small className="form-text text-danger">Invalid Phone Number</small>}
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                                                            Password<span className="text-danger">*</span>
                                                        </label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input
                                                                id="password"
                                                                type="password"
                                                                name="password"
                                                                required
                                                                data-msg="Please enter Password"
                                                                className="input-material"
                                                                onChange={this.handlePasswordChange}
                                                                autoComplete="new-password"
                                                            />
                                                            {this.state.password && (
                                                                <div className="mt-2">
                                                                    <div className="d-flex align-items-center mb-1">
                                                                        <span
                                                                            className={`badge badge-pill ${this.state.passwordStrength && this.state.passwordStrength >= 80
                                                                                ? "badge-success"
                                                                                : this.state.passwordStrength && this.state.passwordStrength >= 50
                                                                                    ? "badge-warning"
                                                                                    : "badge-danger"
                                                                            }`}
                                                                        >
                                                                            {this.state.passwordStrength && this.state.passwordStrength >= 80
                                                                                ? "Strong password"
                                                                                : this.state.passwordStrength && this.state.passwordStrength >= 50
                                                                                    ? "Medium password"
                                                                                    : "Weak password"}
                                                                        </span>
                                                                    </div>
                                                                    <ul className="list-unstyled mb-0 small">
                                                                        <li className={this.state.password.length >= 10 ? "text-success" : "text-muted"}>
                                                                            <i className={`fa ${this.state.password.length >= 10 ? "fa-check" : "fa-circle"} mr-1`} />
                                                                            At least 10 characters
                                                                        </li>
                                                                        <li className={/[A-Z]/.test(this.state.password) ? "text-success" : "text-muted"}>
                                                                            <i className={`fa ${/[A-Z]/.test(this.state.password) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                            At least one uppercase letter (A–Z)
                                                                        </li>
                                                                        <li className={/[a-z]/.test(this.state.password) ? "text-success" : "text-muted"}>
                                                                            <i className={`fa ${/[a-z]/.test(this.state.password) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                            At least one lowercase letter (a–z)
                                                                        </li>
                                                                        <li className={/[0-9]/.test(this.state.password) ? "text-success" : "text-muted"}>
                                                                            <i className={`fa ${/[0-9]/.test(this.state.password) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                            At least one number (0–9)
                                                                        </li>
                                                                        <li className={/[!@#$%^&*_\-+=?]/.test(this.state.password) ? "text-success" : "text-muted"}>
                                                                            <i className={`fa ${/[!@#$%^&*_\-+=?]/.test(this.state.password) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                            At least one special character (! @ # $ % ^ & * _ - + = ?)
                                                                        </li>
                                                                    </ul>
                                                                    {this.state.passwordErrors && this.state.passwordErrors.length > 0 && (
                                                                        <small className="text-danger d-block mt-1">
                                                                            {this.state.passwordErrors[0]}
                                                                        </small>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                                                            Confirm Password<span className="text-danger">*</span>
                                                        </label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input
                                                                id="confirmPassword"
                                                                type="password"
                                                                name="confirmPassword"
                                                                required
                                                                data-msg="Please confirm Password"
                                                                className="input-material"
                                                                onChange={this.handleInputChange}
                                                                autoComplete="new-password"
                                                            />
                                                            {this.state.confirmPassword &&
                                                                this.state.password &&
                                                                this.state.confirmPassword !== this.state.password && (
                                                                    <small className="form-text text-danger">
                                                                        Passwords do not match.
                                                                    </small>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card-header card-header-info d-flex align-items-center">
                                                    <h5>Status Information</h5>
                                                </div>

                                                <div className="form-horizontal p-xl-4">
                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Status<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="status" className="form-control text-capitalize mt-2" required data-msg="Please select status" onChange={this.handleInputChange}>
                                                                <option value={config.ACTIVE}>Active</option>
                                                                <option value={config.INACTIVE}>Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="form-group float-right mt-3">
                                                    <button className='btn btn-primary' disabled={!this.isUserReady()} onClick={this.handleSaveBtnClick}>Create User</button>
                                                </div>
                                            </div>
                                        </div >
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        groups: state.user.groups,
        roles: state.user.roleList,
        courseGroups: state.user.courseGroupList,
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {

        groupList: function () {
            dispatch(groupList())
        },
        roleList: function () {
            dispatch(roleList())
        },
        addUser: function (data: any) {
            dispatch(addUser(data));
        },
        courseGroupList: function () {
            dispatch(courseGroupList())
        },
        logoutUser: function () {
            dispatch(logoutUser());
        },
    }
}
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(AddUser));